//      

import BaseStorage from "./BaseStorage";
                                                      
import Cookies from "js-cookie";

const VZN_CART         = "-vzncart";
const byteSize = str => new Blob([str]).size;
const charSize = 5;
const cookieSizeThreshold = 3000;
const cookieDefaultConfig = {
	expires: 7,
	sameSite: "strict",
};

export default class CookieStorage extends BaseStorage                                        {
	constructor(dealerId        ) {
		super(dealerId, VZN_CART, null);
	}

	get()         {
		const getPaginated = (page = 0, baseString = "") => {
			const cookie = Cookies.get(this.key + "-p" + page);
			if (!cookie) {
				return baseString;
			}
			const newString = baseString + cookie;
			return getPaginated(page + 1, newString);
		};
		return getPaginated();
	}

	set(value)       {
		const setPaginated = (value          , page = 0)       => {
			if (byteSize(value) <= cookieSizeThreshold) {
				return Cookies.set(this.key + "-p" + (page), value, cookieDefaultConfig);
			}
			Cookies.set(this.key + "-p" + (page), value.substring(0, cookieSizeThreshold / charSize), cookieDefaultConfig);
			setPaginated(value.substring(cookieSizeThreshold / charSize, value.length), page + 1);
		};
		this.clear();
		setPaginated(value);
	};

	clear()       {
		const clearPaginated = (page = 0) => {
			Cookies.remove(this.key + "-p" + (page));
			if (Cookies.get(this.key + "-p" + (page + 1))) clearPaginated(page + 1);
		};
		clearPaginated();
	};
}
